export default __webpack_public_path__ + "static/media/ret-res6.ace0831a.jpg";